import { Item as Container } from "./styles";

export function ToggleGroupItem({ children, value }) {
  return (
    <Container value={value} aria-label={value}>
      {children}
    </Container>
  );
}
